var React = require('react');

function NevadaInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3.19415 0L0 85.7103L41.6728 125.673L82.8321 163.973L122.737 200L124.065 194.316L122.779 188.702L122.168 183.128L122.036 176.935L119.861 173.039L121.388 169.456L126.295 169.336L130.83 171.269L134.042 172.322L135.465 167.892L136.448 166.91L135.617 143.77L131.385 0H3.19415Z","fill":"currentColor"}));
}

NevadaInline.defaultProps = {"width":"137","height":"200","viewBox":"0 0 137 200","fill":"none"};

module.exports = NevadaInline;

NevadaInline.default = NevadaInline;
